// Console override utility to disable console output based on environment
const shouldDisableConsole = import.meta.env.VITE_ENABLE_CONSOLE_LOGS !== 'true';

if (shouldDisableConsole) {
  // Store original console methods
  const originalConsole = {
    log: console.log,
    error: console.error,
    warn: console.warn,
    info: console.info,
    debug: console.debug,
    table: console.table,
    group: console.group,
    groupEnd: console.groupEnd,
    time: console.time,
    timeEnd: console.timeEnd,
  };

  // Override console methods with empty functions
  console.log = () => {};
  console.error = () => {};
  console.warn = () => {};
  console.info = () => {};
  console.debug = () => {};
  console.table = () => {};
  console.group = () => {};
  console.groupEnd = () => {};
  console.time = () => {};
  console.timeEnd = () => {};

  // Export original methods in case you need them for debugging
  (window as Window & { __originalConsole?: typeof originalConsole }).__originalConsole = originalConsole;
}